import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { usePartner } from "../../context/PartnerContext";

const homePath = (role) => {
  if (role === "investor") return "/investor";
  if (role === "analyst") return "/analyst";
  if (role === "admin") return "/admin";
  return "/trader";
};

const btn = {
  padding: "6px 14px", borderRadius: 6, border: "1px solid var(--border)",
  background: "transparent", color: "var(--text-main)", cursor: "pointer", fontSize: 12,
};

// Area Partner Admin terpisah dari dashboard trader/investor/analis (layout sendiri).
// Hak akses sebenarnya dicek backend (/api/partner-admin/*) di dalam AdminDashboard.
const PartnerAdminRoute = ({ children }) => {
  const { appName, logoUrl } = usePartner();
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token") || localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  const role = (localStorage.getItem("user_role") || "trader").toLowerCase();
  const signOut = () => {
    ["access_token", "token", "user_role", "user_email"].forEach((k) => localStorage.removeItem(k));
    navigate("/login");
  };
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 28px", borderBottom: "1px solid var(--border)", background: "var(--bg-surface)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, color: "var(--text-main)", fontWeight: 700 }}>
          {logoUrl && <img src={logoUrl} alt="" style={{ height: 24 }} />}
          <span>{appName}</span>
          <span style={{ color: "var(--text-muted)", fontWeight: 400 }}>· Partner Admin</span>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => navigate(homePath(role))} style={btn}>Back to dashboard</button>
          <button onClick={signOut} style={btn}>Sign out</button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PartnerAdminRoute;
